import { themes } from '@/lib/themes'
import { STORY_FONTS } from '@/features/story-conversation/storyFonts'
import type { AppearancePreferences, StoryTextKind } from '@/types/preferences'

export function resolveAppearance(preferences: AppearancePreferences) {
  const theme = themes[preferences.app.themeId]
  const overrides = preferences.story.themes[theme.id]?.colors ?? {}
  const fontFamily = STORY_FONTS[preferences.story.fontId].family
  const normal = overrides.normal ?? theme.preview.text
  const secondary = '#' + theme.vars['--theme-on-surface-variant-rgb']
    .split(' ').map(channel => Number(channel).toString(16).padStart(2, '0')).join('')
  const colors: Record<StoryTextKind, string> = {
    normal, dialogue: overrides.dialogue ?? normal,
    italic: overrides.italic ?? secondary, monospace: overrides.monospace ?? normal,
  }
  const appearanceStyles = {
    '--story-font-family': fontFamily,
    '--story-text-color': colors.normal,
    '--story-dialogue-color': colors.dialogue,
    '--story-italic-color': colors.italic,
    '--story-monospace-color': colors.monospace,
  }
  return { theme, overrides, fontFamily, colors, appearanceStyles }
}
